module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "eso-tags"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      staticClass: "tag",
      on: {
        "click": function($event) {
          _vm.select(index)
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.labelname),
        expression: "labelname"
      }]
    }, [_vm._v(_vm._s(item[_vm.labelname]))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.labelname),
        expression: "!labelname"
      }]
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), _c('i', {
      staticClass: "close"
    })])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-12ff9982!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/tag.vue
// module id = 182
// module chunks = 2